import RadioButton from 'ageas-react-component-radiobutton'
import Section from 'ageas-react-component-section'
import TextField from 'ageas-react-component-textfield'

import { QuestionsBlock } from '../../../Types/AnimalStore'
import { OPTIONS_YES_NO } from '../../../constants/optionsYesNo'
import { t } from '../../../i18n'
import { RadioButtonContainer } from '../../OwnerData/style'
import { DeclarationsContainer, RadioSectionContainer } from '../styles'

type DeclarationsProps = {
  declarations: QuestionsBlock[]
  animalId: string
}

export const Declarations = ({ declarations, animalId }: DeclarationsProps) => {
  return (
    <DeclarationsContainer>
      {declarations.map((declaration, index) => (
        <RadioSectionContainer key={index}>
          <Section
            id="healthSection"
            name={declaration.title}
            config={{ labelSize: '20px', labelBold: '500' }}
            colorTheme="blue"
          />
          <RadioButtonContainer>
            {declaration.questions.map((item) => {
              if (
                item.answer === null ||
                (item.responseTypeCode === 'OT' && item.answer.length === 0)
              )
                return null

              if (item.responseTypeCode === 'OT') {
                return (
                  <TextField
                    readOnly
                    label={item.question}
                    value={item.answer}
                  />
                )
              }

              return (
                <RadioButton
                  readOnly
                  key={`${item.id}-${animalId}`}
                  id={`${item.id}-${animalId}`}
                  name={`${item.id}-${animalId}`}
                  label={item.question}
                  colorTheme="blue"
                  version="2"
                  value={item.answer}
                  options={[
                    { value: OPTIONS_YES_NO.yes, caption: t('general.pt.yes') },
                    { value: OPTIONS_YES_NO.no, caption: t('general.pt.no') },
                  ]}
                />
              )
            })}
          </RadioButtonContainer>
        </RadioSectionContainer>
      ))}
    </DeclarationsContainer>
  )
}
